import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import 'highcharts/modules/accessibility';

function ColumnChart({ height, values, categories, colors, options, yAxis, xAxis }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const yMax = values && Math.max(...values);

    Highcharts.chart(containerRef?.current, {
      chart: {
        type: 'column',
        grouping: false,
        backgroundColor: null,
        height,
        style: options.font,
      },
      accessibility: {
        enabled: true,
        keyboardNavigation: {
          enabled: true,
          focusBorder: {
            enabled: true,
          },
        },
        point: {
          descriptionFormatter(point) {
            if (point.category === 'No data') {
              return 'No data available to display';
            }
            return `${point.category}: ${point.y}`;
          },
        },
      },
      plotOptions: {
        ...options.plotOptions,
        column: {
          ...(options.plotOptions?.column || {}),
          borderWidth: 0.2,
          borderColor: '#2E2E2E',
        },
      },
      title: { text: '' },
      subtitle: { text: '' },
      credits: { enabled: false },
      xAxis: {
        type: 'category',
        categories,
        minorTickLength: 0,
        tickLength: 0,
        title: { text: xAxis },
        labels: { style: options.font },
      },
      yAxis: {
        min: 0,
        max: yMax,
        allowDecimals: true,
        lineWidth: 1,
        title: { text: yAxis },
        labels: { style: options.font },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: true,
        headerFormat: '<b>{point.key}</b><br/>',
        pointFormat: '{point.y}',
        borderRadius: 0,
        shadow: false,
        style: options.font,
      },
      series: [
        {
          data: values,
          dataLabels: { enabled: false },
        },
      ],
      colors,
    });
  }, [height, values, categories, colors, options, yAxis, xAxis]);

  return <div ref={containerRef} />;
}

ColumnChart.propTypes = {
  height: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  colors: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
  yAxis: PropTypes.string.isRequired,
  xAxis: PropTypes.string.isRequired,
};

export default ColumnChart;
